import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Checkbox, FormHelperText } from 'base-ui'

import { useMarketplacePartnerRegisterPageContext } from '../../marketplacePartnerRegisterPageContext'

export const MarketplacePartnerRegisterPageFormBasicInformationsRespectiveLanguage: FC =
  () => {
    const { formState } = useMarketplacePartnerRegisterPageContext()
    formState.use()

    const { model } = formState

    return (
      <div className="flex flex-col gap-4">
        <label className="text-l" htmlFor="customerServiceInRespectiveLanguage">
          <FormattedMessage id="marketplacePartnerRegisterPage.basicInformations.respectiveLanguage.title" />
        </label>
        <div className="flex items-center gap-4">
          <Checkbox
            checked={model.customerServiceInRespectiveLanguage}
            data-qa-id="sellerForm-checkbox-customerServiceInRespectiveLanguage"
            id="customerServiceInRespectiveLanguage"
            onChange={(event): void => {
              formState.setValue(
                event.target.checked,
                model,
                'customerServiceInRespectiveLanguage',
              )
            }}
          />
          <FormattedMessage id="marketplacePartnerRegisterPage.basicInformations.respectiveLanguage.option1" />
        </div>
        {model.validator.getFirstErrorFor(
          'customerServiceInRespectiveLanguage',
        ) && (
          <FormHelperText
            data-qa-id="global-MessageForm-customerServiceInRespectiveLanguage-error-msg"
            error
          >
            {model.validator.getFirstErrorFor(
              'customerServiceInRespectiveLanguage',
            )}
          </FormHelperText>
        )}
      </div>
    )
  }
